
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function ReturnPolicy() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gray-900">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">İade Koşulları</h1>
            <p className="text-xl text-gray-300">
              Sanat eserlerinizin iadesi ile ilgili detaylı bilgiler
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-12">
              
              {/* İade Süresi */}
              <div className="bg-gray-900 rounded-lg p-8">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-600 rounded-lg flex-shrink-0">
                    <i className="ri-time-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold mb-4">İade Süresi</h2>
                    <p className="text-gray-300 leading-relaxed mb-4">
                      Satın aldığınız sanat eserlerini, teslim aldığınız tarihten itibaren <strong>14 gün</strong> içerisinde iade edebilirsiniz. 
                      Bu süre, eserin size ulaştığı tarihten başlar.
                    </p>
                    <ul className="text-gray-300 space-y-2">
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-green-400"></i>
                        Teslim tarihinden itibaren 14 gün
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-green-400"></i>
                        Hafta sonları dahil tüm günler sayılır
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* İade Koşulları */}
              <div className="bg-gray-900 rounded-lg p-8">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-green-600 rounded-lg flex-shrink-0">
                    <i className="ri-shield-check-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold mb-4">İade Koşulları</h2>
                    <p className="text-gray-300 leading-relaxed mb-4">
                      İade edilecek sanat eserlerinin aşağıdaki koşulları sağlaması gerekmektedir:
                    </p>
                    <ul className="text-gray-300 space-y-3">
                      <li className="flex items-start gap-3">
                        <i className="ri-check-line text-green-400 mt-1"></i>
                        <span>Eser orijinal ambalajında ve hasarsız durumda olmalıdır</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-check-line text-green-400 mt-1"></i>
                        <span>Çerçeve ve koruyucu malzemeler eksiksiz olmalıdır</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-check-line text-green-400 mt-1"></i>
                        <span>Eser üzerinde herhangi bir hasar bulunmamalıdır</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-check-line text-green-400 mt-1"></i>
                        <span>Satış faturası ve sertifika eksiksiz olmalıdır</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* İade Süreci */}
              <div className="bg-gray-900 rounded-lg p-8">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-purple-600 rounded-lg flex-shrink-0">
                    <i className="ri-refresh-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold mb-4">İade Süreci</h2>
                    <p className="text-gray-300 leading-relaxed mb-6">
                      İade işleminizi başlatmak için aşağıdaki adımları takip edin:
                    </p>
                    <div className="space-y-6">
                      <div className="flex items-start gap-4">
                        <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full text-sm font-bold flex-shrink-0">1</div>
                        <div>
                          <h3 className="font-semibold mb-2">İletişime Geçin</h3>
                          <p className="text-gray-300 text-sm">
                            İade talebinizi bildirmek için bizimle iletişime geçin. E-posta veya telefon ile ulaşabilirsiniz.
                          </p>
                        </div>
                      </div>
                      <div className="flex items-start gap-4">
                        <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full text-sm font-bold flex-shrink-0">2</div>
                        <div>
                          <h3 className="font-semibold mb-2">İade Onayı</h3>
                          <p className="text-gray-300 text-sm">
                            İade talebiniz değerlendirildikten sonra size onay ve iade adresi bilgisi gönderilir.
                          </p>
                        </div>
                      </div>
                      <div className="flex items-start gap-4">
                        <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full text-sm font-bold flex-shrink-0">3</div>
                        <div>
                          <h3 className="font-semibold mb-2">Kargo Gönderimi</h3>
                          <p className="text-gray-300 text-sm">
                            Eseri güvenli bir şekilde paketleyerek belirtilen adrese gönderin. Kargo ücreti tarafımızca karşılanır.
                          </p>
                        </div>
                      </div>
                      <div className="flex items-start gap-4">
                        <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full text-sm font-bold flex-shrink-0">4</div>
                        <div>
                          <h3 className="font-semibold mb-2">İnceleme ve İade</h3>
                          <p className="text-gray-300 text-sm">
                            Eser tarafımıza ulaştıktan sonra incelenir ve uygun bulunursa 5-7 iş günü içinde ödeme iadeniz yapılır.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* İade Edilemeyen Durumlar */}
              <div className="bg-red-900/20 border border-red-800 rounded-lg p-8">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-red-600 rounded-lg flex-shrink-0">
                    <i className="ri-close-circle-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold mb-4 text-red-300">İade Edilemeyen Durumlar</h2>
                    <p className="text-gray-300 leading-relaxed mb-4">
                      Aşağıdaki durumlarda eserler iade edilemez:
                    </p>
                    <ul className="text-gray-300 space-y-2">
                      <li className="flex items-center gap-2">
                        <i className="ri-close-line text-red-400"></i>
                        Özel sipariş üzerine hazırlanan eserler
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-close-line text-red-400"></i>
                        Hasarlı veya kirlenmiş eserler
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-close-line text-red-400"></i>
                        14 günlük süreyi aşan iade talepleri
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-close-line text-red-400"></i>
                        Eksik belgeli iade talepleri
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* İletişim Bilgileri (replaced) */}
              <div className="mb-8">
                <h2 className="text-2xl font-bold mb-4">İletişim</h2>
                <p className="text-gray-300 mb-4">
                  İade işlemleri ve sorularınız için bizimle iletişime geçin:
                </p>
                <div className="bg-gray-800 p-6 rounded-lg">
                  <p className="text-white mb-2"><strong>Nox Sanat</strong></p>
                  <p className="text-gray-300 mb-2">
                    Gayrette Mahallesi, Çimen Sokak, Girne Apartmanı<br />
                    Beşiktaş / İstanbul
                  </p>
                  <p className="text-gray-300 mb-2">Telefon: +90 212 555 0123</p>
                  <p className="text-gray-300 mb-2">E-posta: info@noxsanat.com</p>
                  <p className="text-gray-300">Çalışma Saatleri: Pazartesi - Cumartesi: 09:00 - 18:00</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
